import PropTypes from 'prop-types';
import React from 'react';

const QuickValuesHistogramWidgetCreateConfiguration = React.createClass({
  propTypes: {
    config: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  },

  getInitialConfiguration() {
    return {};
  },

  render() {
    return null;
  },
});

export default QuickValuesHistogramWidgetCreateConfiguration;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/components/widgets/configurations/QuickValuesHistogramWidgetCreateConfiguration.jsx